import { NodeTypes, RuleNode } from '../../shared/models/rule-node'
import { Edge, Node } from 'reactflow'
import { BaseNodeData } from './components/nodes/base/types'
import _ from 'lodash'
import { RuleNodeId } from '../../shared/models/id/rule-node-id'
import { RuleChainId } from '../../shared/models/id/rule-chain-id'
import { RuleEdge } from '../../shared/models/rule-node-edge'

export interface CustomEdge {
  id: string
  source: string
  target: string
  data: EdgeData
}

/**
 * @description Convert the edges from the format that is stored in the database to the format that is used in the ReactFlow graph.
 * @param edgeFmt
 */
export const edgeLibsFromEdgesFmts = (
  edgeFmt: RuleEdge[]
): Edge<EdgeData>[] => {
  return _.chain(edgeFmt)
    .groupBy(({ fromNodeID, toNodeID }) => `${fromNodeID.id}-${toNodeID.id}`)
    .map((edges, key) => {
      return {
        id: key,
        source: edges[0].fromNodeID.id,
        target: edges[0].toNodeID.id,
        label: _.map(edges, 'linkLabel').join(' && ') || '',
        type: 'kopiliotDefault',
        data: {
          linkLabels: _.map(edges, 'linkLabel'),
        },
      }
    })
    .value()
}

export const edgesFmtsFromEdgeLibs = (edges: Edge<EdgeData>[]): RuleEdge[] => {
  return _.chain(edges)
    .filter((edge) => edge.source != 'main_input')
    .flatMap((edge) =>
      _.map(edge.data?.linkLabels, (lb) => ({
        fromNodeID: new RuleNodeId(edge.source),
        toNodeID: new RuleNodeId(edge.target),
        linkLabel: lb,
      }))
    )
    .value()
}

/*
  EdgeData is the data that is stored in the ReactFlow graph. In the data field of the Edge.
 */
export interface EdgeData {
  linkLabels: string[]
}

export const nodeLibFromNodeFmt = (
  nodeFmt: RuleNode
): Node<BaseNodeData<any>, string | undefined> => {
  return {
    id: nodeFmt.id?.id ? nodeFmt.id.id : '',
    type: nodeFmt.type,
    position: {
      x: nodeFmt.positionX,
      y: nodeFmt.positionY,
    },
    data: {
      id: nodeFmt.id,
      name: nodeFmt.name,
      //description: nodeFmt.description,
      isDebugMode: nodeFmt.debugMode,
      configuration: nodeFmt.configuration,
    },
    draggable: true,
    deletable: true,
    selectable: true,
  }
}

export const nodesLibsFromNodesFmts = (
  nodeFmt: RuleNode[]
): Node<BaseNodeData<any>, string | undefined>[] => {
  return nodeFmt.map((node) => nodeLibFromNodeFmt(node))
}

export const ruleNodeFmtFromNodeLib = (
  nodeLib: Node<BaseNodeData<any>, string | undefined>,
  ruleChainID: RuleChainId
): RuleNode => {
  return {
    id: nodeLib.data.id,
    name: nodeLib.data.name,
    type: nodeLib.type as NodeTypes,
    debugMode: nodeLib.data.isDebugMode ? nodeLib.data.isDebugMode : false,
    positionX: nodeLib.position ? nodeLib.position.x : 0,
    positionY: nodeLib.position ? nodeLib.position.y : 0,
    configuration: nodeLib.data.configuration ? nodeLib.data.configuration : {},
    ruleChainID: ruleChainID,
  }
}
